<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :onConfigReady="onQueryConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
import { Vue, MsgBox } from '../../app.vues'

import { checkUserActionPerm } from '../index'
import { getDefaultPageSizes } from '../../app.conf'

import merchtComnApi from '../../api/merchtComn'

import SwbRealComSave from './RealComSave';

Vue.regist(SwbRealComSave);

import SwbRealComDetail from './RealComDetail';

Vue.regist(SwbRealComDetail);

export default {
    name: 'swb-retailer-real-com-list-select',
    desc: '零售商实体公司列表',
    props: ['realMerchantId', 'bizUnitId'],
    data: function () {
        return {
            confKey: 'swb-real-com-list-select',
            queryOnLoad: true,
            // 分页信息
            theTableHeight: 520,
            //
            needPager: true, //是否需要分页（默认：true）
            multiSelect: false, //是否多选（默认：false）
            multiPageSelect: false, //是否要多页/跨页选择（默认：false）
            rowKeyPropName: 'id', //记录数据关键标识列名（多页/跨页选择必须，默认: id）
            rowNoShow: true, //是否显示行号（默认：true）
            rowNoFixed: true, //行号列是否固定（默认：false）

            btnColName: '',//操作列名称（如果不设置就不显示操作列）
            //
            btnColTitle: '操作',//操作列标题（默认：'操作'）
            btnColWidth: 250,//操作列宽度（默认：100）
                             //
            btnColFixed: true, //操作列是否固定
            //
            pageSize: getDefaultPageSizes().first(),
            pageNumber: 1,
            // 过滤信息
            queryKey: null,
            queryModel: {
                filterItems: {},
                sortItemList: [],
                sortItems: {}
            },
            // 其他信息
            dataList: [],
            taxPayTypeMap: getEnumMap('taxPayType', 'value2text')
        }
    },
    created: function () {
    },
    mounted() {
        this.initResultTable();
    },
    destroyed() {
        //释放domSizeWatcher
        let domSizeWatcher = this.domSizeWatcher;
        if(domSizeWatcher != null) {
            domSizeWatcher.clear();
            this.domSizeWatcher = null;
        }
    },
    methods: {
        onQueryConfigReady: function (event) {
            //
            let taxPayTypeList = getEnumList('taxPayType');
            if(!Utils.isNoB(taxPayTypeList) && taxPayTypeList.length > 0) {
                let dataList = [];
                dataList.push({'value': null, 'label': '-全部-'});
                taxPayTypeList.forEach(function (item) {
                    dataList.push({
                        value: item.value,
                        label: item.text
                    });
                });
                this.updateQueryModelField('taxPayType', dataList);
            }
        },
        updateQueryModelField: function (itemCode, dataList = []) {
            if(itemCode != null) {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let data = {dataList: dataList};
                let fieldInfo = {};
                fieldInfo[itemCode] = data;
                query_model_ctrl.updateFields(fieldInfo);
            }
        },
        initResultTable() {
            let self = this;
            let query_model_ctrl = this.$refs['query_model_ctrl'];
            let resultTable = this.$refs['result_table'];
            //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
            resultTable.setQrySortRef(query_model_ctrl);
            //
            resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                'taxPayType': function (row, colName, colValue, rowIndex) {
                    if(!Utils.isNoB(row.taxPayType)) {
                        return '<span>' + self.taxPayTypeMap[row.taxPayType] + '</span>';
                    }
                }
            }, /* 单元格按钮点击处理函数 */{
                //*代表可处理未指定事件函数的任意列的按钮/链接的点击
            });
        },
        renderTable(rows, pagination) {
            let resultTable = this.$refs.result_table;
            //清除数据（如果已经渲染的数据与新的列不是一回事儿）
            //resultTable.clear();
            //同步使用新的自定义列信息
            //resultTable.initMeta(confColList);
            //设置新数据
            let tableData = {
                rows: rows,
                pagination: pagination
            };

            resultTable.render(tableData);
        },
        // 单元格点击事件
        rowDblClickHandler: function (row) {
            if(!this.multiSelect) {
                console.log('----- 双击数据行 ----');
                console.log(row);
            }
        },
        getTableSelection() {
            let resultTable = this.$refs.result_table;
            return resultTable.getSelection();
        },
        checkActionPerm: function (action) {
            return checkUserActionPerm(Vue.$getClassInfo(this).path, action, null);
        },
        pageNoChangeHandler: function (pageNumber, pageSize) {
            console.log('分页 => 第【' + pageNumber + '】页，大小：' + pageSize);
            //
            this.pageSize = pageSize;
            this.pageNumber = pageNumber;
            //
            this.getDataList();
        },
        queryHandler: function (queryModel) {
            this.queryModel = queryModel;
            this.pageNumber = 1;
            this.getDataList();
        },
        getDataList() {
            let self = this;
            let postData = {};
            postData.pagination = {
                pageSize: self.pageSize,
                pageNumber: self.pageNumber,
            };
            //
            let queryModel = self.queryModel;
            let filterItems = Utils.merge({}, queryModel.filterItems);
            let sortItemList = Utils.merge([], queryModel.sortItemList);
            let sortItems = Utils.merge({}, queryModel.sortItems);
            //
            if(!Utils.isNoB(this.realMerchantId)) {
                filterItems.realMerchantId = this.realMerchantId;
            }
            if(!Utils.isNoB(this.bizUnitId)) {
                filterItems.bizUnitId = this.bizUnitId;
            }
            //
            postData.filterItems = filterItems;
            postData.sortItemList = sortItemList;
            postData.sortItems = sortItems;
            //
            let theLoading = MsgBox.loading();
            merchtComnApi.getRetailerRealComList(postData, function (result) {
                theLoading.close();
                if(result.type == 'info') {
                    self.dataList = result.data.rows;
                    self.totalCount = result.data.pagination.totalCount;
                    self.renderTable(result.data.rows, result.data.pagination);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getDlgResult() {
            let relCom = this.getTableSelection();
            let result = {};
            if(Utils.isNoB(relCom)) {
                result.type = 'warn';
                result.message = '请选择实体公司！';
            } else {
                result.type = 'info';
                result.data = relCom;
            }
            return result;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/comn/RetailerRealComListSelect.vue